import { useMemo } from 'react';
import { useLocation } from 'react-router';
import { cn } from '@/lib/utils';
import { findNavigationItem, headerNavigationItems } from '@/lib/navigation';

export function PageHeader({
  title,
  description,
  icon: IconOverride,
  actions,
  className,
  titleClassName,
}) {
  const location = useLocation();

  const navItem = useMemo(() => {
    return findNavigationItem(location.pathname, headerNavigationItems);
  }, [location.pathname]);

  const resolvedTitle = title || navItem?.label;
  const Icon = IconOverride || navItem?.icon;

  return (
    <div className={cn('flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between', className)}>
      <div>
        <h1 className={cn('flex items-center gap-3 text-2xl font-bold text-foreground sm:text-3xl', titleClassName)}>
          {Icon && <Icon className="h-8 w-8 shrink-0 text-primary sm:h-9 sm:w-9" aria-hidden="true" />}
          {resolvedTitle}
        </h1>
        {description && (
          <p className="mt-1 text-sm text-muted-foreground sm:text-base">
            {description}
          </p>
        )}
      </div>
      {actions && (
        <div className="flex flex-col gap-2 sm:flex-row sm:items-center">
          {actions}
        </div>
      )}
    </div>
  );
}
